<template>
  <div>
    <!-- <vue-headful v-bind:title="$t('salary-calculator.metadata.title')" v-bind:description="$t('salary-calculator.metadata.description')" ogLocale="sv_SE" lang="sv-SE"/>         -->

    <Hero
      img="/images/work-1.jpeg"
      v-bind:title="$t('salary-calculator.hero.title')"
      v-bind:preamble="$t('salary-calculator.hero.preamble')"
    />

    <section id="salary-calculator">
      <div class="section-content">
        <form>
          <div class="container">
            <div class="row">
              <div class="col-md-12 d-none d-md-block">
                {{ $t('salary-calculator.calculator.calculation-prefix') }}<br/>
                <span class="calculated-salary">{{ calc | salaryFormat }} {{ $t('salary-calculator.calculator.calculation-suffix')}}</span>
              </div>
              <div class="col-md-6 order-md-2 mb-3 mb-md-0">
                {{ $t('salary-calculator.hero.body') }}
              </div>
              <div class="col-md-6 order-md-1">
                <div class="form-group">
                  <div>
                    <label for="rate" class="input-name" v-text="$t('salary-calculator.calculator.rate-label-text')"></label>
                    <div class="input-value">
                      {{ rate.value }} {{ $t('salary-calculator.calculator.rate-value-suffix') }}
                    </div>
                  </div>
                  <input
                    type="range"
                    class="form-control-range"
                    id="rate"
                    :min="rate.min"
                    :max="rate.max"
                    :step="rate.stepValue"
                    v-model="rate.value"
                  />
                  <div>
                    <label for="vacation" class="input-name"  v-text="$t('salary-calculator.calculator.vacation-label-text')"></label>
                    <div class="input-value">{{ vacation.value }} {{ $t('salary-calculator.calculator.vacation-value-suffix') }}</div>
                  </div>
                  <input
                    type="range"
                    class="form-control-range"
                    id="vacation"
                    :min="vacation.min"
                    :max="vacation.max"
                    v-model="vacation.value"
                  />
                  <div>
                    <label for="occupancy-rate" class="input-name" v-text="$t('salary-calculator.calculator.occupancyRate-label-text')"></label>
                    <div class="input-value">
                      {{ occupancyRate.value | occupancyRateFormat }} {{ $t('salary-calculator.calculator.occupancyRate-value-suffix') }}
                    </div>
                  </div>
                  <input
                    type="range"
                    class="form-control-range"
                    id="occupancy-rate"
                    :min="occupancyRate.min"
                    :max="occupancyRate.max"
                    :step="occupancyRate.stepValue"
                    v-model="occupancyRate.value"
                  />
                  <div>
                    <label for="pension-provision" v-text="$t('salary-calculator.calculator.pensionProvision-label-text')"></label>
                    <div class="input-value">{{ pensionProvision.value }} {{ $t('salary-calculator.calculator.pensionProvision-value-suffix') }}</div>
                  </div>
                  <input
                    type="range"
                    class="form-control-range"
                    id="pension-provision"
                    :min="pensionProvision.min"
                    :max="pensionProvision.max"
                    :step="pensionProvision.stepValue"
                    v-model="pensionProvision.value"
                  />
                </div>
              </div>
              <div class="col-md-6 d-md-none">
                {{ $t('salary-calculator.calculator.calculation-prefix') }}<br/>
                <span class="calculated-salary">{{ calc | salaryFormat }} {{ $t('salary-calculator.calculator.calculation-suffix')}}</span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import { getSalary } from "../calculateSalary";
import Hero from "../components/Hero.vue";

export default {
  name: "app",
  components: {
    Hero,
  },
  data: function () {
    return {
      occupancyRate: {
        min: 0.5,
        max: 1,
        stepValue: 0.01,
        value: 1,
      },
      pensionProvision: {
        min: 2000,
        max: 15000,
        stepValue: 500,
        value: 6000,
      },
      rate: {
        min: 600,
        max: 1500,
        stepValue: 5,
        value: 900,
      },
      vacation: {
        min: 15,
        max: 50,
        value: 30,
      },
    };
  },
  filters: {
    occupancyRateFormat: function (value) {
      return Number(value).toLocaleString(undefined, { style: "percent" });
    },
    salaryFormat: function (value) {
      return Number(value).toLocaleString("sv-SE", {
        maximumFractionDigits: 0,
      });
    },
  },
  computed: {
    calc() {
      return getSalary(
        this.rate.value,
        this.vacation.value,
        this.occupancyRate.value,
        this.pensionProvision.value
      );
    },
  },
};
</script>

<style scoped>
.form-control-range {
  -webkit-appearance: none;
  background-color: #5496D3;
  width: 100%;
  height: 10px;
  border-radius: 5px;
  margin-bottom: 16px;
}
.form-control-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  background-color: white;
  border: 1px solid #343a40;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  outline: none;
}
.form-control-range::-moz-range-thumb {
  -webkit-appearance: none;
  background-color: white;
  border: 1px solid #343a40;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  outline: none;
}
.form-control-range::-ms-thumb {
  -webkit-appearance: none;
  background-color: white;
  border: 1px solid #343a40;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  outline: none;
}

.calculated-salary {
  font-size: 2rem;
}

.input-name {
  float: left;
}
.input-value {
  float: right;
}
</style>